// src/components/LoginPage.js
import React, { useState } from 'react';
import './LoginPage.css'; // We will create this CSS file next

const LoginPage = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = (e) => {
    e.preventDefault(); // Prevents the form from reloading the page
    // --- This is our mock authentication ---
    if (username === 'Alex' && password === 'password123') {
      setError('');
      onLogin({
        username: 'Alex',
        dob: 'October 25, 2002',
        occupation: 'College Student',
        about: 'A passionate reader and aspiring novelist. Loves fantasy, sci-fi, and classic literature. Currently studying computer science and spends free time exploring virtual and literary worlds.'
      });
    } else {
      setError('Invalid credentials. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleLogin}>
        <h2>Welcome to BookWorld</h2>
        <p>Please sign in to continue</p>
        <div className="input-group">
          <label htmlFor="username">Username</label>
          <input
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Hint: Alex"
          />
        </div>
        <div className="input-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Hint: password123"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default LoginPage;